import React from 'react';
import Grid from '@mui/material/Grid';
import FilterContainer from 'Containers/FilterContainer';
import Search from 'Components/Search';
import Dropdown from 'Components/DropDown';
import Toogle from 'Components/Toogle';
import { searchGridStyle, dropdownGridStyle } from './FiltersBar.styled';

export interface FiltersBarPropsI {
  searchPlaceholder: string;
  statusTitle: string;
  authorTitle: string;
  categoryTitle: string;
  terminalTitle: string;
  statusOptions: string[];
  authors: string[];
  categories: string[];
  terminals: string[];
  isCard: boolean;
  onNameChange: (value: string) => void;
  onStatusChange: (value: string) => void;
  onAuthorChange: (value: string) => void;
  onCategoryChange: (value: string) => void;
  onTerminalChange: (value: string) => void;
  onToggleView: (value: boolean) => void;
}

export default function FiltersBar({
  searchPlaceholder,
  statusTitle,
  authorTitle,
  categoryTitle,
  terminalTitle,
  statusOptions,
  authors,
  categories,
  terminals,
  isCard,
  onNameChange,
  onStatusChange,
  onAuthorChange,
  onCategoryChange,
  onTerminalChange,
  onToggleView,
}: FiltersBarPropsI) {
  return (
    <FilterContainer>
      <Grid item xs={4} style={searchGridStyle}>
        <Search placeholder={searchPlaceholder} setData={onNameChange} />
      </Grid>
      <Grid item xs={8} style={dropdownGridStyle}>
        {/* DropDown antepone "Todos" (Generic.All) y regresa '' al elegirla;
            el hook interpreta '' como "sin filtro". Mismo orden que el legacy:
            Estatus, Autor, Categoría, Terminal. */}
        <Dropdown title={statusTitle} setData={onStatusChange} options={statusOptions} />
        <Dropdown title={authorTitle} setData={onAuthorChange} options={authors} />
        <Dropdown title={categoryTitle} setData={onCategoryChange} options={categories} />
        <Dropdown title={terminalTitle} setData={onTerminalChange} options={terminals} />
        <Toogle value={isCard} onclick={onToggleView} />
      </Grid>
    </FilterContainer>
  );
}
